export function membershipTypeRank(value: unknown): number {
  const typeId = parseInt(String(value ?? 0), 10)
  if (!Number.isFinite(typeId) || typeId <= 0) return 0

  // Pathfinder/Discoverer (id=10) has the same booking access as Insider.
  if (typeId === 10) return 1

  return typeId
}

export function isFreeMembershipPrice(value: unknown): boolean {
  if (value === null || value === undefined || value === '') return false
  const amount = Number(value)
  return Number.isFinite(amount) && amount === 0
}

export function isMembershipInsufficient(currentType: unknown, requiredType: unknown): boolean {
  const requiredRank = membershipTypeRank(requiredType)
  return requiredRank > 0 && membershipTypeRank(currentType) < requiredRank
}

export function getRequiredMembershipTag(tags: unknown[]): any {
  if (!Array.isArray(tags)) return null

  let selected: any = null
  let selectedRank = 0

  for (const tag of tags as any[]) {
    const typeId = parseInt(String(tag?.membershiptype_id ?? 0), 10)
    if (!Number.isFinite(typeId) || typeId <= 0) continue

    const rank = membershipTypeRank(typeId)
    if (rank > selectedRank) {
      selected = {
        ...tag,
        membershiptype_id: rank,
        membershipname: rank === 1 ? 'Insider' : tag?.membershipname
      }
      selectedRank = rank
    }
  }

  return selected
}
